import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class SearchInput extends Vue {
	inputValue = '';

	@Prop({
		default: 'Wyszukaj'
	})
	placeholder!: String;

	handleInputChange(ev: any) {
		this.inputValue = ev.target.value;

		this.emitChange(this.inputValue);
	}

	clearInput() {
		this.inputValue = '';

		this.emitChange(this.inputValue);
	}

	emitChange(value: string) {
		this.$emit('inputChange', value);
	}

	get isInputFilled() {
		return this.inputValue.length > 0;
	}
}
